import { DotLegalFile } from "@dotlegal/dotlegal-ui-components";
import { DocumentSaveModel } from "../../../documents/Documents.types";
import { deleteHttp, sendWithFile } from "../../../common/api/apiShared";
import { useUploadProgress } from "@common/components/uploadProgress/useUploadProgress";
import { IResearchEthicsApprovalReportDocuments } from "./ResearchEthicsApprovalReportDocuments";
import { useDotLegalFileUploadDataMapping } from "../../../common/components/dotLegalFileUploadTable/DotLegalFileUploadTable.hooks";
import { useState } from "react";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useResearchEthicsApprovalReportDocumentsHooks(props: IResearchEthicsApprovalReportDocuments) {
    const [isSaving, setIsSaving] = useState(false);
    const { uploadPercentage, trackUploadProgress } = useUploadProgress();

    const { downloadDocument } = useDotLegalFileUploadDataMapping();

    const removeDocumentMutation = useDotLegalMutation((documentId: string) =>
        deleteHttp(`/researchEthicsApprovalReport/${props.processingActivityId}/documents/${documentId}`)
    );

    const removeDocument = (documentId: string) => {
        props.onRemoveDocument(documentId);
        removeDocumentMutation.mutateAsync(documentId);
    };

    const createDocumentMutation = useDotLegalMutation((upload: { document: DocumentSaveModel; file: File }) =>
        sendWithFile("POST", `/researchEthicsApprovalReport/${props.processingActivityId}/documents`, upload.document, upload.file, trackUploadProgress())
    );

    const createDocuments = async (files: Array<DotLegalFile> | undefined) => {
        if (files) {
            setIsSaving(true);
            try {
                for (const file of files) {
                    await createDocumentMutation.mutateAsync({ document: { fileName: file.fileName }, file: file.file });
                }
            } finally {
                props.refetch();
                setIsSaving(false);
            }
        }
    };

    return {
        downloadDocument,
        createDocuments,
        removeDocument,
        isSaving,
        uploadPercentage,
    };
}
